export default __webpack_public_path__ + "static/media/T160MAND1.12d96e02.pdf";